import React from "react";
import { doc, increment, updateDoc } from "firebase/firestore";
import MainStore from "../../stores/MainStore";
import db from "../../firebase/fireInit";
import useHover from "../../hooks/useHover";

const Checkmark = ({
  onChecked,
  points,
  worth,
  size = "25px",
  divWidth,
  checkmarkRef,
  blackWhite,
  useOpacity,
}) => {
  const { player } = MainStore();
  const hover = useHover();
  function increaseCheckmark() {
    const playerRef = doc(db, "players", player.uid);
    if (points && worth)
      updateDoc(playerRef, {
        checkmarks: increment(1),
        points: increment(points),
        worth: increment(worth),
      });
    else if (points)
      updateDoc(playerRef, {
        checkmarks: increment(1),
        points: increment(points),
      });
    else if (worth)
      updateDoc(playerRef, {
        checkmarks: increment(1),
        worth: increment(points),
      });
    else updateDoc(playerRef, { checkmarks: increment(1) });
  }
  return (
    <img
      {...hover.divProps}
      ref={checkmarkRef}
      src="/icons/icon_checkmark.png"
      style={{
        opacity: useOpacity ? (hover.hover ? 1 : 0.5) : null,
        cursor: "pointer",
        width: divWidth ?? "100%",
        objectFit: "contain",
        height: size,
        filter: blackWhite ? "grayscale(100%)" : null,
      }}
      onClick={() => {
        increaseCheckmark();
        onChecked();
      }}
    />
  );
};

export default Checkmark;
